import type { AxiosInstance, AxiosRequestConfig } from 'axios';
import type { RouteLocationNormalized } from 'vue-router';
import axios from 'axios';
import { useABTestStore } from '@/features/flow/ABTesting';
import { pushEvent } from '@/shared/analytics';

export function usePushEvent() {
  const httpConfig: AxiosRequestConfig = {
    baseURL: import.meta.env.VUE_APP_API_V3_URL,
    withCredentials: true,
  };

  const http: AxiosInstance = axios.create(httpConfig);

  const abStore = useABTestStore();

  return async (
    eventName: string,
    fromRoute: RouteLocationNormalized,
    additionalParams?: Record<string, unknown>,
  ) => {
    const referrer = `${location.origin}${fromRoute.fullPath}`;

    await pushEvent(
      http,
      {
        referrer,
        experimentGroups: abStore.experimentGroups,
        additionalParams,
        eventName,
      },
    );
  };
}
